import React, { Component, createRef } from 'react';
import { bool, array, string, func } from 'prop-types';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';

import styles from './Dropdown.css';

class Dropdown extends Component {
  static propTypes = {
    emptyState: string,
    customClasses: string,
    opts: array.isRequired,
    disabled: bool,
    label: string,
    size: string,
    darkBg: bool,
    simplified: bool,
    red: bool,
    autoWidth: bool,
    withoutIcon: bool,
    noEmptyState: bool,
    onChange: func,
  };

  static defaultProps = {
    opts: [],
    emptyState: '- Choose One -'
  };

  dropdownRef = createRef();
  selectedMeterRef = createRef();

  state = {
    checkedOption: 0,
    dropdownWidth: null
  };

  componentDidMount = () => {
    const { autoWidth } = this.props;

    if (autoWidth) {
      this.setState({
        dropdownWidth: this.getSelectedValueWidth()
      });
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { autoWidth } = this.props;
    const newWidth = this.getSelectedValueWidth();

    if (autoWidth && prevState.dropdownWidth !== newWidth) {
      this.setState({ dropdownWidth: newWidth });
    }
  }

  handleChange = () => {
    const { onChange } = this.props;

    this.setState({ checkedOption: this.getSelectedValue() });

    onChange && onChange();
  }

  getSelectedValueWidth = () => this.selectedMeterRef.current.getClientRects()[0].width + 20;

  getSelectedValue = () => {
    return this.dropdownRef.current.value;
  }

  renderSelectOptions = () => {
    const { emptyState, opts, noEmptyState } = this.props;
    const allOptions = noEmptyState ? opts : [emptyState, ...opts];

    return (
      allOptions.map((opt, i) =>
        <option key={`option-${i}`} value={i}>
          {opt}
        </option>
      )
    );
  }

  render() {
    const { darkBg,
      disabled,
      label,
      size,
      simplified,
      red,
      customClasses,
      autoWidth,
      opts,
      emptyState,
      withoutIcon,
      noEmptyState,
    } = this.props;
    const { checkedOption, dropdownWidth } = this.state;

    const calculatedDropdownWidth = autoWidth && dropdownWidth
      ? dropdownWidth + 'px'
      : 'auto';

    // Styles
    const cx = classnames.bind(styles);

    const inputFieldClasses = cx(styles[size], styles.inputField, customClasses, {
      disabled,
      withLabel: label,
      darkBg,
      withoutIcon,
    });

    const selectClasses = cx(
      styles.select,
      size && styles[size],
      {
        isSelected: checkedOption > 0,
        simplified,
        red
      }
    );

    const selectedMeterClasses = cx(
      styles.select,
      styles.selectedMeter
    );

    const selectProps = {
      disabled,
      ref: this.dropdownRef,
      value: checkedOption,
      className: selectClasses,
      onChange: this.handleChange
    };

    let iconProps = {
      icon: 'chevron-down',
      type: '15'
    };

    const allOptions = noEmptyState ? opts : [emptyState, ...opts];
    const selectedOption = allOptions[checkedOption];

    switch (size) {
      case 's':
      case 'm':
      case 'l':
        iconProps.icon = 'chevron-down';
        iconProps.type = '20';
        break;
      case 'xl':
        iconProps.type = '30';
        break;
      default:
        break;
    }

    // Edge case
    if (size === 'l' && simplified) {
      iconProps.icon = 'chevron-down-25';
      iconProps.type = 'other';
    }

    return (
      <div style={{ width: calculatedDropdownWidth }} className={inputFieldClasses}>
        { label && <label className={styles.label}>{label}</label> }

        <select {...selectProps}>
          { this.renderSelectOptions() }
        </select>

        { !withoutIcon && <Icon {...iconProps} /> }

        <div ref={this.selectedMeterRef} className={selectedMeterClasses}>
          { selectedOption }
        </div>
      </div>
    );
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/Dropdown.js